import { EquipmentStateName } from '@frontend/equipment/types';

export const getLendingEquipmentStateNavigateTarget = (state: EquipmentStateName): string => {
    if (state === EquipmentStateName.EQUIPMENT_IN_USE) {
        return '../utilizations';
    }

    return '../inventory';
};
